import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GDAccountNumberCell from 'Components/GDTable/GDAccountNumberCell/GDAccountNumberCell.jsx';
import summaryIcon from 'Assets/img/clipboard-list-light.svg';
import LessIcon from 'Assets/img/angle-up-light.svg';
import MoreIcon from 'Assets/img/angle-down-light.svg';
import moment from 'moment';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import { customFormatclass, customClassSummary } from '../GDCustomFormat/GDCustomFormat';
import './GDTableSummaryPanel.scss';
import { VITE_isIE } from 'Constants/appEnvConstants';

class GDTableSummaryPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false,
    };


    this.attachBindings();
  }
  attachBindings() {
    this.getRenderedItems = this.getRenderedItems.bind(this);
  }
  toggle = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  }
  getRenderedItems() {
    return this.state.isExpanded ? this.props.summaryColumns : this.props.summaryColumns.filter((listItem) => {
      return listItem.defaultIsVisible == true;
    });
  }

  render() {
    const divStyle = {
      display: 'flex',
      alignItems: 'center',
    };

    const mainContentClass = VITE_isIE ? 'gd-table__summary-panel gd-table__summary-panel-ie' : 'gd-table__summary-panel';
    return (

      <div className={mainContentClass}>

        <div style={divStyle} className="gd-table__summary-panel-title">
          <img src={summaryIcon} height="25px" width="20px" className="titleIcon" />
          <h2 style={{ paddingLeft: 10, marginBottom: 12 }}>{this.props.title}</h2>
        </div>

        <br />

        <ul className="gd-table__summary-panel-list">
          {this.getRenderedItems().map((column, index) => {
            let valueClass;
            if ((column.displayType === 'CURRENCY' || column.displayType === 'NEGATIVE_NUMBER') && Number.parseFloat(this.props.summaryContent[column.columnKey].value === undefined ? this.props.summaryContent[column.columnKey] : this.props.summaryContent[column.columnKey].value) < 0) {
              valueClass = customFormatclass(customClassSummary, column.displayType);
            } else if (Number.parseFloat(this.props.summaryContent[column.columnKey]) < 0) {
              valueClass = customFormatclass(customClassSummary, column.displayType);
            }

            const handlePrecision = (amount, precision) => {
              if (amount !== undefined && amount !== null) {
                const arr = `${amount}`.split('.');
                return arr.length > 1
                  ? `${arr[0] <= 0 ? arr[0] * -1 : arr[0]}.${arr[1].length === 1 ? `${arr[1]}0` : arr[1].substr(0, precision)}`
                  : `${amount <= 0 ? amount * -1 : amount}.00`;
              }
              return '--';
            };
            const handleEmptyValues = (dataVal) => {
              if (dataVal === null || dataVal === undefined) { return '--'; } else { return dataVal; }
            };

            let value;
            if (column.displayType === 'CURRENCY') {
              value = handlePrecision(this.props.summaryContent[column.columnKey].value === undefined ? this.props.summaryContent[column.columnKey] : this.props.summaryContent[column.columnKey].value, 2);
            } else if (column.displayType === 'STRING') {
              value = handleEmptyValues(this.props.summaryContent[column.columnKey]);
            } else if (column.displayType === 'NEGATIVE_NUMBER') {
              value = handlePrecision(this.props.summaryContent[column.columnKey], 2);
            } else if (column.displayType === 'ACCOUNTNUMBER') {
              value = (this.props.summaryContent[column.columnKey]
                && (
                  <GDAccountNumberCell
                    isReadOnly={this.props.isReadOnly}
                    accountNumber={(this.props.summaryContent[column.columnKey])}
                    token={this.props.summaryContent[column.secondaryColumnKey === undefined ? 'globalToken' : column.secondaryColumnKey]}
                  />
                ));
            } else if (column.displayType === 'INDICATOR') {
              value = this.props.summaryContent[column.columnKey] === '1' ? 'Yes' : 'No';
            } else if (column.displayType === 'DATE') {
              value = this.props.summaryContent[column.columnKey] ? moment(this.props.summaryContent[column.columnKey]).format(this.props.dateFormat): '--';
            }
            else if (column.displayType === 'DUEDATE') {
              value = this.props.summaryContent[column.columnKey] && this.props.summaryContent[column.columnKey] != '' ? moment(this.props.summaryContent[column.columnKey]).format(this.props.dateFormat) : '--';
            } else {
              value = this.props.summaryContent[column.columnKey];
            }

            return (
              <li
                className="gd-table__summary-panel-list-item"
                key={column.columnKey}
              >


                <div className="gd-table__summary-panel-list-item-wrapper">
                  <span className="gd-table__summary-panel-list-item-label">
                    {column.name}

                  </span>
                  <span className={valueClass || 'gd-table__summary-panel-list-item-amount'}>
                    {value}
                    {column.displayType == 'RC'
                      && (
                        <InformationBubble
                          id={column.columnKey}
                          info
                          tooltipContent={this.props.summaryContent[column.descriptionKey]}
                        />
                      )

                    }

                  </span>
                </div>
              </li>
            );
          })}

        </ul>
        {this.props.isToggle
          ? (
            <div onClick={this.toggle}>
              {this.state.isExpanded ? <img src={LessIcon} className="gd-table__summary-panel-reduce" />
                : <img src={MoreIcon} className="gd-table__summary-panel-extend" />}

            </div>
          )
          : <div />
        }

      </div>

    );
  }
}
GDTableSummaryPanel.propTypes = {
  extraClass: PropTypes.string,
  summaryColumns: PropTypes.array.isRequired,
  summaryContent: PropTypes.array.isRequired,
  title: PropTypes.string,
};

GDTableSummaryPanel.defaultProps = {
  extraClass: '',
  title: '',
  summaryColumns: [],
  summaryContent: {},
};

export default GDTableSummaryPanel;
